import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Paper, AppBar, Toolbar, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import PublicIcon from '@material-ui/icons/Public';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  }
}));

const UniqueCss = () => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const menuList = [
    { text: 'Markets', icon: <AccountBalanceIcon /> }, 
    { text: 'Technology', icon: <PhoneAndroidIcon /> }, 
    { text: 'US', icon: <LocalActivityIcon /> }, 
    { text: 'Global', icon: <PublicIcon /> }]

  return (
    <div style={{ textAlign: 'left' }}>
      <h1>CSS: Unique Selectors</h1>
      <p>The code on the right is supposed to print a log to console when the user clicks "LOG IN" on the left hand <span style={{fontStyle: 'italic', fontWeight: 600}}>sidenav</span> of the screen below.</p>
      <p>Unfortunately, the CSS selector assigned to the "selector" variable is too generic and causes the code to log when the LOG IN button in the <span style={{fontStyle: 'italic', fontWeight: 600}}>header</span> is clicked.</p>
      <p><strong>Test the current code to see what happens:</strong></p>
      <ol>
        <li>Click the "RUN" button to execute the click listener code on the right</li>
        <li>Open your dev tools console</li>
        <li>Click the LOG IN button in the sidenav. Notice a console message "The user clicked the login button!!!"</li>
        <li>Click the LOG IN button in the header. Notice the same message appears. We DO NOT want the message to appear when we click this button in the header.</li>
      </ol>
      <p>Change the CSS selector so it only logs a message to console when the user clicks the LOG IN option in the sidenav. </p>
      <Paper elevation={3} className={classes.root} id="unique-root">
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              My News
            </Typography>
            <Button className="login-button" style={{ color: 'white' }} startIcon={<PersonIcon />}>Log in</Button>
          </Toolbar>
        </AppBar>
        {/* <Drawer anchor={'left'} open={open} onClose={() => setOpen(false)} id="unique-drawer" variant="permanent"> */}
        <Paper style={{ width: 'fit-content', height: '500px%' }}>
          <List>

            {menuList.map((item, index) => (
              <ListItem button key={item.text}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}

            <Divider />
            <ListItem>

              <Button className="login-button" startIcon={<PersonIcon />}>Log in</Button>
            </ListItem>

          </List>
        </Paper>

        {/* </Drawer> */}

      </Paper>
    </div>
  )

}

export default UniqueCss;